export const DEFAULT_LANGUAGE = 'en';

export const SUPPORTED_LANGUAGES = [
    { code: 'en', nativeLabel: 'English' },
    { code: 'es', nativeLabel: 'Español' },
    { code: 'fr', nativeLabel: 'Français' },
];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((item) => item.code);

export function normalizeLanguage(code) {
    if (!code) {
        return null;
    }
    const normalized = String(code).trim().toLowerCase();
    return SUPPORTED_LANGUAGE_CODES.includes(normalized) ? normalized : null;
}

export function userStorageKey(user) {
    const name = user && (user.user_name || user.userName || user.UserName);
    if (name && String(name).trim()) {
        return String(name).trim().toLowerCase();
    }
    return 'anon';
}
